import Login from './views/Authentication'
import Home from './views/Home'
import Profile from './views/Profile'
import Admin from './views/Admin'
import News from './views/News'
import Documents from './views/Documents'
import AddDocument from './views/AddDocument'
import DocumentInfo from './views/DocumentInfo'
import Events from './views/Events'
import Notifications from './views/Notifications'
import AddNews from './views/AddNews'
import NewsInfo from './views/NewsInfo'
import MemberInfo from './views/MemberInfo'
import NewMember from './views/NewMember'
import Reset from './views/Reset'
import NotMatch from './views/NotMatch'
import PWAStatus from './components/PWAStatus'
import {Route, Switch, Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'


function App() {
  const {user} = useSelector(state => state.login)
  return (
    <div className="App">
      <PWAStatus/>
      <Switch>
        <Route path='/' exact>
          <Login/>
        </Route>
        <Route path='/reset'>
          <Reset/>
        </Route>
        <Route path='/home'>
          {user ? <Home/> : <Redirect to='?redirect=home'/>}
        </Route>
        <Route path='/news' exact>
          {user ? <News/> : <Redirect to='?redirect=news'/>}
        </Route>
        <Route path='/documents' exact>
          {user ? <Documents/> : <Redirect to='?redirect=documents'/>}
        </Route>
        <Route path='/documents/new'>
          {user && (user.data.isAdmin || user.data.isCoAdmin) ? <AddDocument/> : <Redirect to='/documents'/>}
        </Route>
        <Route path='/documents/:id'>
          {user ? <DocumentInfo/> : <Redirect to='?redirect=documents'/>}
        </Route>
        <Route path='/events' exact>
          {user ? <Events/> : <Redirect to='?redirect=events'/>}
        </Route>
        <Route path='/notifications' exact>
          {user ? <Notifications/> : <Redirect to='?redirect=notifications'/>}
        </Route>
        <Route path='/me'>
          {user ? <Profile/> : <Redirect to='?redirect=me'/>}
        </Route>
        <Route path='/info/:id'>
          {user ? <MemberInfo/> : <Redirect to='?redirect=info'/>}
        </Route>
        <Route path='/admin'>
          {user && (user.data.isAdmin || user.data.isCoAdmin) ? <Admin/> : <Redirect to='/home'/>}
        </Route>
        <Route path='/news/new'>
          {user && (user.data.isAdmin || user.data.isCoAdmin) ? <AddNews/> : <Redirect to='/news'/>}
        </Route>
        <Route path='/new'>
          {user && (user.data.isAdmin || user.data.isCoAdmin) ? <NewMember/> : <Redirect to='/news'/>}
        </Route>
        <Route path='/news/:id'>
          {user ? <NewsInfo/> : <Redirect to='?redirect=news/:id'/>}
        </Route>
        <Route path='*' component={NotMatch}/>
      </Switch> 
    </div>
  );
}

export default App;
